import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgCommentMenu = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H19.99L20 20L16 16H0V0ZM4 12H16V10H4V12ZM16 9H4V7H16V9ZM4 6H16V4H4V6Z"
      fill="#6750A4"
    />
  </svg>
);

export default SvgCommentMenu;
